function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.01,
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 0a2 2 0 0 1 2 2v2h5a2 2 0 0 1 2 2v38a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5V2a2 2 0 0 1 2-2h18zM13 6H8v38h32V6h-5v1a2 2 0 0 1-2 2H15a2 2 0 0 1-2-2V6zm3 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm19 2v2H23v-2h12zm-19 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-12a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm19 2v2H23v-2h12zm-19 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-12a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm19 2v2H23v-2h12zm-19 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM33 2H15v5h18V2z"
}));

var SvgChecklist = function SvgChecklist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checklist.989570e0.svg";
export { ForwardRef as ReactComponent };